export const REMOVE_SP_COMPANY_REGISTRATION_DATA = 'REMOVE_SP_COMPANY_REGISTRATION_DATA';
export const SET_SP_COMPANY_REGISTRATION_CURRENT_STEP = 'SET_SP_COMPANY_REGISTRATION_CURRENT_STEP';
export const SET_SP_COMPANY_REGISTRATION_FILLED_STEPS_COUNT = 'SET_SP_COMPANY_REGISTRATION_FILLED_STEPS_COUNT';
export const SET_SP_COMPANY_REGISTRATION_VISITED_STEPS_COUNT = 'SET_SP_COMPANY_REGISTRATION_VISITED_STEPS_COUNT';

export const SET_SP_COMPANY_MAIN_INFO = 'SET_SP_COMPANY_MAIN_INFO';
export const SET_SP_COMPANY_EMAIL_VERIFICATION_INFO = 'SET_SP_COMPANY_EMAIL_VERIFICATION_INFO';
export const SET_SP_COMPANY_REGISTRATION_RECAPTCHA_TOKEN = 'SET_SP_COMPANY_REGISTRATION_RECAPTCHA_TOKEN';
export const SET_SP_COMPANY_EMAIL_VERIFICATION_REQUESTED = 'SET_SP_COMPANY_EMAIL_VERIFICATION_REQUESTED';
export const SET_SP_COMPANY_CLIENT_AVATAR = 'SET_SP_COMPANY_CLIENT_AVATAR';
export const SET_SP_COMPANY_SERVICES_INFO = 'SET_SP_COMPANY_SERVICES_INFO';

export const SET_SERVICES_SP_COMPANY = 'SET_SERVICES_SP_COMPANY';
export const SET_CERTIFICATES_SP_COMPANY = 'SET_CERTIFICATES_SP_COMPANY';
export const SET_REGIONS_SP_COMPANY = 'SET_REGIONS_SP_COMPANY';
export const SET_EMPLOYEES_AMOUNT_SP_COMPANY = 'SET_EMPLOYEES_AMOUNT_SP_COMPANY';

export const SET_SP_COMPANY_EMPLOYEES_AMOUNT_INFO_LOADING = 'SET_SP_COMPANY_EMPLOYEES_AMOUNT_INFO_LOADING';
export const SET_SP_COMPANY_EMPLOYEES_AMOUNT_INFO_LOADING_ERRORS = 'SET_SP_COMPANY_EMPLOYEES_AMOUNT_INFO_LOADING_ERRORS';
export const SET_SP_COMPANY_REGIONS_INFO_LOADING = 'SET_SP_COMPANY_REGIONS_INFO_LOADING';
export const SET_SP_COMPANY_REGIONS_INFO_LOADING_ERRORS = 'SET_SP_COMPANY_REGIONS_INFO_LOADING_ERRORS';
export const SET_SP_COMPANY_SUGGEST_INFO_LOADING = 'SET_SP_COMPANY_SUGGEST_INFO_LOADING';
export const SET_SP_COMPANY_SUGGEST_INFO_LOADING_ERRORS = 'SET_SP_COMPANY_SUGGEST_INFO_LOADING_ERRORS';
export const SET_SP_COMPANY_CERTIFICATES_INFO_LOADING = 'SET_SP_COMPANY_CERTIFICATES_INFO_LOADING';
export const SET_SP_COMPANY_CERTIFICATES_INFO_LOADING_ERRORS = 'SET_SP_COMPANY_CERTIFICATES_INFO_LOADING_ERRORS';
export const SET_SP_COMPANY_SERVICES_INFO_LOADING = 'SET_SP_COMPANY_SERVICES_INFO_LOADING';
export const SET_SP_COMPANY_SERVICES_INFO_LOADING_ERRORS = 'SET_SP_COMPANY_SERVICES_INFO_LOADING_ERRORS';
export const SET_SP_COMPANY_CERTIFICATION_INFO = 'SET_SP_COMPANY_CERTIFICATION_INFO';
export const SET_SP_COMPANY_RECOMMENDATION_INFO = 'SET_SP_COMPANY_RECOMMENDATION_INFO';
export const SET_SP_COMPANY_SOCIAL_NETWORK_LINK_INFO = 'SET_SP_COMPANY_SOCIAL_NETWORK_LINK_INFO';
export const SET_SP_COMPANY_IP_ADDRESS_INFO = 'SET_SP_COMPANY_IP_ADDRESS_INFO';
export const SET_COMPANY_SUGGESTIONS_FOR_SP = 'SET_COMPANY_SUGGESTIONS_FOR_SP';
